/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { useLogger } from '@airasia-rn/core-logger';
import {
  trackFeedItemClick,
  trackFeedHeaderTap,
  trackFooterChipTap,
  TrackFeedItemClickParams,
} from '../social/Social.actions';
import {
  trackApiError,
  TrackApiErrorParams,
} from '../apiErrors/ApiErrors.actions';
import { EVENT_NAMES } from '../social/Social.meta';

export const useSocialAnalytics = () => {
  const { logEvent, logError } = useLogger();

  return {
    trackFeedItemClick: (params: TrackFeedItemClickParams) => {
      logEvent(EVENT_NAMES.MOVEMENTS_CLICK, trackFeedItemClick(params));
    },
    trackFeedHeaderTap: (sectionId: string, labelType: string) => {
      logEvent(EVENT_NAMES.TAP, trackFeedHeaderTap(sectionId, labelType));
    },
    trackFooterChipTap: (chipId: string, labelType: string) => {
      logEvent(EVENT_NAMES.TAP, trackFooterChipTap(chipId, labelType));
    },
    trackApiError: (params: TrackApiErrorParams) => {
      logError('api_error', trackApiError(params));
    },
  };
};
